import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactPlayer from 'react-player';
export const StyledVideoContent = styled.section`
  display: flex;
  flex-direction: column;
`;
export const StyledDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.2rem;
  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    flex-direction: column;
    margin-bottom: 1rem;
  }
`;
export const StyledTitleContainer = styled.div`
  display: inline;
  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    margin-bottom: 0.7rem;
  }
`;
export const StyledTitle = styled.span`
  margin-right: 0.6rem;
  color: ${({
  theme
}) => theme.colors.addButton.textHover};
  font-size: 1.8rem;
`;
export const StyledDate = styled.span`
  color: ${({
  theme
}) => theme.colors.text.lighter};
  font-size: ${({
  theme
}) => theme.fonts.sizes.small};
`;
export const StyledSourceContainer = styled(StyledDate)`
  font-size: ${({
  theme
}) => theme.fonts.sizes.tiny};
  display: flex;
  align-items: center;
  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    justify-content: flex-end;
  }
`;
export const StyledVideoPlayback = styled(ReactPlayer)<{
  $isTHMVideo?: boolean;
}>`
  width: auto !important;
  flex: ${props => props.$isTHMVideo && 1};
`;